import { render, staticRenderFns } from "./CornerNotification.vue?vue&type=template&id=1d412eec&scoped=true"
import script from "./CornerNotification.vue?vue&type=script&lang=js"
export * from "./CornerNotification.vue?vue&type=script&lang=js"
import style0 from "./CornerNotification.vue?vue&type=style&index=0&id=1d412eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d412eec",
  null
  
)

export default component.exports